export default __webpack_public_path__ + "static/media/footer-location.fe9c24bd.svg";